/**
 * Componente para separadores de fecha en la transcripción
 * Muestra "Hoy" si es el día actual, sino muestra la fecha formateada
 */
export const DateSeparator = ({ date }) => {
  if (!date) return null;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  const messageDate = new Date(date);
  messageDate.setHours(0, 0, 0, 0);
  
  const isToday = messageDate.getTime() === today.getTime();
  
  let displayText = 'Hoy';
  if (!isToday) {
    const day = String(messageDate.getDate()).padStart(2, '0');
    const month = String(messageDate.getMonth() + 1).padStart(2, '0');
    const year = messageDate.getFullYear();
    displayText = `${day}/${month}/${year}`;
  }

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      margin: '16px 0',
      width: '100%'
    }}>
      <div style={{
        flex: 1,
        height: '1px',
        backgroundColor: '#e1e5ea'
      }}></div>
      <span style={{
        padding: '0 12px',
        fontSize: '12px',
        color: '#687078',
        backgroundColor: '#fff',
        fontFamily: 'Helvetica, Arial, sans-serif'
      }}>
        {displayText}
      </span>
      <div style={{
        flex: 1,
        height: '1px',
        backgroundColor: '#e1e5ea'
      }}></div>
    </div>
  );
};

export default DateSeparator;

